export default "/img/CN.ad58b6a0eebf93d385108ebd59f10e7f.png";